<template>
  <v-app>
    <v-toolbar app class="">
      <v-toolbar-title class="headline text-uppercase">
        <span>MyBetBot</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
      >
      </v-btn>
    </v-toolbar>

    <v-content>
      <HelloWorld/>
    </v-content>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  data () {
    return {
      //
      //adicionar autenticação
      //https://acloud.guru/course/intro-aws-appsync/learn/b5c27987-4d7f-e76f-2f0f-33dd050a0707/4a9a7d07-fd82-a024-da61-37fed7f36c9e/watch?backUrl=%2Fcourses
    }
  }
}
</script>
